import React from 'react';
import { Activity, Users as UsersIcon, Bell, AlertTriangle } from 'lucide-react';
import { useSupabaseClient } from '../utils/supabase';

function Dashboard() {
  const [stats, setStats] = React.useState({
    activeUsers: 0,
    totalEndpoints: 0,
    alertTypes: 0,
    totalWebhooks: 0
  });

  React.useEffect(() => {
    const fetchStats = async () => {
      const supabase = useSupabaseClient();
      
      // Fetch statistics from Supabase
      const [
        { count: usersCount },
        { count: endpointsCount },
        { count: alertTypesCount },
        { count: webhooksCount }
      ] = await Promise.all([
        supabase.from('users').select('*', { count: 'exact' }),
        supabase.from('endpoints').select('*', { count: 'exact' }),
        supabase.from('alert_types').select('*', { count: 'exact' }),
        supabase.from('webhooks').select('*', { count: 'exact' })
      ]);

      setStats({
        activeUsers: usersCount || 0,
        totalEndpoints: endpointsCount || 0,
        alertTypes: alertTypesCount || 0,
        totalWebhooks: webhooksCount || 0
      });
    };

    fetchStats();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Dashboard</h1>
      
      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {/* Stats cards */}
        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <UsersIcon className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    Active Users
                  </dt>
                  <dd className="text-lg font-semibold text-gray-900">
                    {stats.activeUsers}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Bell className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    Total Endpoints
                  </dt>
                  <dd className="text-lg font-semibold text-gray-900">
                    {stats.totalEndpoints}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <AlertTriangle className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    Alert Types
                  </dt>
                  <dd className="text-lg font-semibold text-gray-900">
                    {stats.alertTypes}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="p-5">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Activity className="h-6 w-6 text-gray-400" />
              </div>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    Total Webhooks
                  </dt>
                  <dd className="text-lg font-semibold text-gray-900">
                    {stats.totalWebhooks}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;